@if (viewModel$ | async; as viewModel) {
  <nav class="font-bold text-lg flex" role="menu">
    @for (route of viewModel.routes; track route.path) {
      <a
        [routerLink]="route.path"
        routerLinkActive="link--active"
        class="link"
        role="menuitem"
        >
        <svg class="w-6 h-6 mr-2.5 text-sky-500">
          <use [attr.xlink:href]="route.icon"></use>
        </svg>
        {{route.name}}
      </a>
    }
  </nav>

  <a
    [routerLink]="viewModel.notificationsPath"
    class="relative ml-4 mr-2 inline-flex items-center"
    aria-label="Notifications"
    data-testid="notifications-link"
  >
    <svg class="w-6 h-6 text-sky-500" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.08 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
    </svg>
    @if (activeRequestCount$ | async; as count) {
      @if (count > 0) {
        <span data-testid="notifications-badge" class="absolute -top-1 -right-2 bg-red-500 text-white text-xs rounded-full min-w-5 h-5 px-1 flex items-center justify-center">
          {{ count > 99 ? '99+' : count }}
        </span>
      }
    }
  </a>
}

<em-dashboard-header-user-dropdown/>
